import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type TrainingResetProps = BaseNotificationItemProps & {
  type: 'training_reset'
  program: {
    id: string
    displayName: string
    color: string
    iconType?: string
  }
}

export function TrainingReset({ program, ...props }: TrainingResetProps) {
  return (
    <NotificationItem
      {...props}
      title={`${program.displayName} Training Reset`}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{`You've used all the requalification attempts for ${program.displayName}. To become eligible again, complete the program's training from the start.`}</p>
      }
    />
  )
}
